/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import Pagination from "../../../../Helper/Pagination";
import { MoonLoader } from "react-spinners";
import defaultImg from "../../../../assets/img/thumbnail.png";

export default function PersonalShopperList() {
  const [PersonalShopperList, setPersonalShopperList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedState, setselectedState] = useState("");

  useEffect(() => {
    GetList();
  }, [search_key, currentPage]);

  const GetList = async () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };
    PostService(API_URL.GET_PERSONAL_SHOPPER_LIST, param).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          setPersonalShopperList(res.data.data.rows);
          SetTotalPageCount(res.data.totalPages);
          SetTotalCount(res.data.totalItems);
          setCount(res.data.currentPage * param.limit);
          setLoading(false);
        } else {
          showErrorAlert(res.data?.message);
          setLoading(false);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
        setLoading(false);
      }
    );
  };

  function Delete(ID, name) {
    const id = {
      id: ID,
    };

    showDeleteConfirmation(name, () => {
      PostService(API_URL.DELETE_PERSONAL_SHOPPER, id).then(
        (res) => {
          if (res.data.status) {
            showSuccessAlert(res?.data?.message, GetList);
          } else {
            showErrorAlert(res.data?.message);
          }
        },
        (err) => {
          showErrorAlert(err.data?.message);
        }
      );
    });
  }

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>Personal Shopper List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">
                  Personal Shopper List
                </Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row px-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar p-0">
                        <input
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          className="form-control"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                    <div class="table-responsive mt-4">
                      {!loading && (
                        <table class="table table-hover table-bordered table-striped">
                          <thead>
                            <tr>
                              <th>S.No</th>
                              <th>User Name</th>
                              <th>Email</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {PersonalShopperList &&
                              PersonalShopperList?.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + S_No_Count + 1}</td>
                                  <td>
                                    {item?.firstname} {item?.lastname}
                                  </td>
                                  <td>{item?.email} </td>
                                  <td>
                                    <span
                                      title="view"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      data-toggle="modal"
                                      data-target="#ViewModal"
                                      onClick={() => {
                                        setselectedState(item);
                                      }}
                                    >
                                      <i className="text-warning fas fa-eye"></i>{" "}
                                    </span>
                                    <span
                                      title="Delete"
                                      style={{ cursor: "pointer" }}
                                      className="mx-2"
                                      onClick={() => {
                                        Delete(
                                          item?.personalshopperid,
                                          "Personal Shopper"
                                        );
                                      }}
                                    >
                                      <i className="text-danger fas fa-trash"></i>{" "}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            {PersonalShopperList &&
                              PersonalShopperList.length === 0 && (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    <h6 className="p-3"> No Data Found </h6>
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      )}

                      {loading ? (
                        <div className="LoaderSpinner">
                          <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                          <div>Loading... Please wait.</div>
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-4">
                        <Pagination
                          counting={S_No_Count}
                          totaldata={TotalCount}
                          pagecount={TotalPageCount}
                          onChangePage={handlePageClick}
                          activePage={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* / View MODAL-------------------- / */}
      <div
        className="modal fade"
        id="ViewModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header bg-light">
              <h4 className="modal-title" id="exampleModalLabel">
                View Personal Shopper
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="mt-3">
              <div className="row mx-3">
                <div className="col-md-4">
                  <label>User Name :</label>
                </div>
                <div className="col-md-8 ">
                  <p>
                    {selectedState?.firstname} {selectedState?.lastname}
                  </p>
                </div>
              </div>

              <div className="row mx-3">
                <div className="col-md-4">
                  <label>Email :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.email || "N/A"}</p>
                </div>
              </div>
              <div className="row mx-3">
                <div className="col-md-4">
                  <label>Question 1 :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.question1}</p>
                </div>
              </div>
              <div className="row mx-3">
                <div className="col-md-4">
                  <label>Question 2 :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.question2}</p>
                </div>
              </div>

              <div className="row mx-3">
                <div className="col-md-4">
                  <label>Copyright :</label>
                </div>
                <div className="col-md-8 ">
                  <p>{selectedState?.copyright}</p>
                </div>
              </div>
              <div className="row my-3">
                <div className="col-md-8 offset-md-4">
                  <img
                    className="CommonImage"
                    src={
                      selectedState?.uploadimage
                        ? selectedState?.uploadimage
                        : defaultImg
                    }
                    alt="..."
                    onError={(e) => {
                      e.target.src = defaultImg;
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* / View MODAL- End ------------------- / */}
    </div>
  );
}
